import { WebchatMessage, TactfulAttachments } from '@/libs/WebchatClient';
import storage from '@/libs/SafeStorage';
import { Button, QuickReply } from './index';
import { AudioContent } from "@tactful/sdk";
let mustache = require('mustache');
import { da } from 'date-fns/locale';
import { format, endOfDay, isToday, isWithinInterval, subDays } from 'date-fns';

const locales = { da };


export interface IMessage {
  text?: string;
  quick_replies?: QuickReply[];
  attachment?: any;
  type?: string;
  dataFormat?: string;
  timestamp?: number;
  currentSession?: string;
  quick_reply?: QuickReply;
  postback?: any;
  format?: string;
  source?: string;
  sender?: any;
  sender_name?: string;
  sender_picture?: string;
  from?: string;
  to?: boolean;
  audioContent?: AudioContent;
  tactfulAttachments?: TactfulAttachments[];
}
export class Message {

  constructor() { }

  formatReceiveMessage(message: IMessage) {
    if (!message.timestamp) {
      message.timestamp = message.timestamp || Date.now();
    }
    if (message.timestamp && typeof (message.timestamp) != 'number') {
      message.timestamp = parseInt(message.timestamp);
    }
    //check source agent/user
    if (message.source && message.source != "user") {
      message.to = true;
    }
  }
  getAgentName(message: IMessage, isHistory?: boolean) {
    let agentName = null;
    if (message.sender && message.source == 'inbox') {
      agentName = (message.sender && message.sender.name) ? message.sender.name : 'Agent';
    }

    if (isHistory) {
      agentName = (message.sender && message.sender_name) ? message.sender_name : 'Agent';
    }
    return agentName;
  }
  getAgentImage(message: IMessage, isHistory?: boolean) {
    let agentImage = null;
    if (message.sender && message.source == 'inbox') {
      agentImage = (message.sender && message.sender.picture) ? message.sender.picture : '';
    }

    if (isHistory) {
      agentImage = (message.sender && message.sender_picture) ? message.sender_picture : '';
    }

    return agentImage;
  }
  checkThreadIdentity(message: IMessage) {
    return this.getAgentName(message) ? 'Agent' : 'Bot';
  }
  updateMessageSender(message: IMessage, agentName: string) {
    if (!message.attachment && message.source != 'user') {
      message.from = agentName;
    }
  }
  cleanText(text: string) {
    let regex = /[{}|<>]/g;
    let cleanText = text.replace(regex, " ");
    return cleanText;
  }
  renderMessage(template: string, obj: any) {
    if (typeof (template) === 'string' && obj)
      return mustache.render(template, obj);
    else
      console.error("render needs a string and object has matched variable");
  }
  detectLang(title: string) {
    let arabicRex = /[\u0600-\u06FF]/;
    if (arabicRex.test(title)) {
      return true;
    } else {
      return false;
    }
  }
  getTarget(button: Button) {
    let target = "_top";
    if (button && button.webview_height_ratio === "tall") target = "_self";
    return target;
  }
  getMessageClass(messageColor: string, messageColorText: string) {
    return {
      'background-color': messageColor,
      'color': messageColorText,
      'margin-left': '10px'
    };
  }
  isProductsList(msg: IMessage) {
    return !!(msg?.tactfulAttachments?.some((attachment) => attachment?.type === 'generic'));
  }
  isTextButton(msg: IMessage) {
    const isAttchment = (
      msg.attachment
      && msg.attachment.type == "template"
      && msg.attachment.payload.template_type == "button"
      && msg.attachment.payload.text
    );
    return isAttchment;
  }
  link(text: string, linkTarget: string) {
    let target = linkTarget;
    let urlRegex = /(https?:\/\/[^\s]+)/g;
    let astrikesExist = /(\*{1}(.*?)\*{1})/g;
    let formattedMsg = text;
    text = text.replace(/&#x2F;/g, '/');
    formattedMsg = text.replace(astrikesExist, function (bold) {
      return (
        '<b class="boldText">' + bold.slice(1, bold.length - 1) + '</b>'
      );
    }).replace(urlRegex, function (url) {
      return (
        '<a style="word-break: break-all;" href="' + url + '" target="' + target + '">' + url + "</a>"
      );
    });
    return formattedMsg;
  }
  isValidMessage(message: IMessage) {
    if (!message) return false;
    let excludeMessage = ['command', 'whisper', 'event_message', 'system_logs', 'note'];
    return (!excludeMessage.includes(message.text) && !excludeMessage.includes(message.type)) || this.isTextButton(message) || message.source === 'user'; // message.source to allow any action buttons msg to be rendered
  }
  isSentByPrevMessageSender(message: IMessage, prevMessage: IMessage) {  //check identity of message sender
    const { to: prevMessageReciever, from: prevMessageSender } = prevMessage || {};
    const { to: messageReciever, from: messageSender } = message || {};
    return prevMessageReciever && messageReciever && messageSender && messageSender === prevMessageSender;
  }
  formatMessageDate(time: string, lang?: string) {
    return time ? this.formatTimestamp(time, lang) : "";
  }
  formatText(text: string, numberOfChars: number) {
    if (text && text.length >= numberOfChars) {
      return text = text.substring(0, numberOfChars) + '..';
    } else {
      return text;
    }
  }
  formatTextMessage(text: string, tactfulAttachments: []) {
    if (text != "") {
      let message: IMessage = {};
      message.text = this.cleanText(text) || '';
      message.format = "text";
      // this.sendMessage(message);
      return message;
    } else if (tactfulAttachments.length != 0) {
      let message: IMessage = {};
      message.text = '';
      message.format = '';
      // this.sendMessage(message);
      return message;
    }
  }
  formatSendMessage(message: IMessage, tactfulAttachments: []) {
    let sendMessage: WebchatMessage = {
      type: "message"
    };
    if (message) {
      sendMessage.text = message.text || null;
    }
    sendMessage.timestamp = Date.now();
    if (message && message.quick_reply) {
      sendMessage.quick_reply = { payload: message.quick_reply.payload };
    }

    if (message && message.postback) {
      sendMessage.postback = message.postback;
    }
    if (message && message.format) {
      sendMessage.format = message.format;
    }
    if (tactfulAttachments && tactfulAttachments.length > 0) {
      sendMessage.tactfulAttachments = tactfulAttachments;
    }
    return sendMessage;
  }
  constructTactfulAttachments(attachment: any) {
    let tactfulAttachments: TactfulAttachments = {
      id: attachment.id,
      type: attachment.type,
      fileSize: attachment.originalSize,
      title: attachment.name,
      url: null,
      originalURL: null,
      previewURL: null,
      contentLength: null,
      coordinatesLat: null,
      coordinatesLong: null,
      element: {},
      stickerId: null
    };
    return tactfulAttachments;
  }
  checkWebexPostback(parsedPayload: any) {
    if (parsedPayload && parsedPayload.ENABLE_MEET && parsedPayload.mail && parsedPayload.department) {
      return true;
    }
  }
  clearQuickReplies(msg: IMessage, messages: IMessage[], getLastTenMessages: boolean) {
    if (messages && messages.length > 1) {
      let len = messages.length - 1;
      if (messages[len].quick_replies) {
        messages[len].quick_replies = [];
      }
    }
    messages.push(msg);
    if (messages.length > 10 && getLastTenMessages) {
      let end = messages.length - 10;
      messages.splice(0, end);
    }
    return messages;
  }
  sendQuickReply(index: number, quickReply: QuickReply, vueComponent: any) {
    vueComponent.$emit("sendQuickReply", index, vueComponent.messageIndex);
  }
  showingDate(message: IMessage) {
    let allow = message.text || this.isTextButton(message);
    return allow;
  }
  recievedMessage(msg: IMessage, timestamp: number) {
    let isNewMessage = msg.timestamp >= timestamp;
    let isBotMessage = (msg.source === 'bot' || msg.from === 'Bot');
    let isAgentMessage = msg.source === 'inbox';
    return (isNewMessage && (isBotMessage || isAgentMessage));
  }
  getUnreadCount(messages: IMessage[]) {
    let timestamp = parseInt(storage.get('unreadCountTimestamp'));
    let count = 0;
    for (let msg of messages) {
      count = this.recievedMessage(msg, timestamp) ? ++count : count;
    }
    return count;
  }
  setunreadMessagesTimestamp(timestamp: number) {
    storage.set('unreadCountTimestamp', timestamp.toString());
  }
  checkUrlContainsHttp(url: string) {
    let httpRegex = /^(http(s)?):\/\/?/;
    if (httpRegex.test(url)) {
      return url;
    } else {
      return 'https://' + url;
    }
  }
  formatTimestamp(timestamp: string, lang?: string) {
    if (!timestamp) return "";
    const isLocalization = lang !== "en" && lang !== "ar";
    let date;
    try {
      date = new Date(timestamp);

      // Check for today
      if (isToday(date)) {
        return format(date, "hh:mm a"); // Format as time (e.g., 5:00 PM)
      }
      // Check for within the last week
      const lastWeekStart = subDays(new Date(), 7);
      if (
        isWithinInterval(date, {
          start: lastWeekStart,
          end: endOfDay(new Date()),
        })
      ) {
        return isLocalization ? format(date, 'eee, hh:mm a') : format(date, 'eee, hh:mm a', { locale: locales[lang] }); // Format as day of the week (e.g., Sun, 05:00 PM)
      }
      // Otherwise, format as date Oct.,17 04:20PM
      return isLocalization ? format(date, "MMM dd, hh:mm a", { locale: locales[lang] }) : format(date, "MMM dd, hh:mm a");
    } catch {
      return "";
    }
  }
}